import { LoadingStateWithIdle } from "../../data-layer/loading-state-with-idle";
import { useEqualState } from "../../../hooks";

export function useStaleWhileRevalidate<T>(resource: LoadingStateWithIdle<T>): LoadingStateWithIdle<T> {
  const [state, setState] = useEqualState({ resource, hasEverBeenLoaded: resource.__tag === "loaded" });

  if (!state.hasEverBeenLoaded) {
    if (resource.__tag === "error" || resource.__tag === "loaded") {
      setState({ resource, hasEverBeenLoaded: true });
    }
  } else {
    if (resource.__tag === "error" || resource.__tag === "loaded") {
      setState({ resource, hasEverBeenLoaded: true });
    }
  }

  return state.resource;
}
